export default __webpack_public_path__ + "static/media/Avatar-13.21f5579e.png";